import lottie from 'lottie-web';

export default class LoadScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'LoadScene',
    });
  }

  preload() {
    this.load.json('loading-anim', 'assets/loadAnims/cuemath_loading.json');
  }

  create() {
    this.loadingAnim = this.addLoaderLottie(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
    );

    this.startSceneAssetsLoad();
    this.endSceneAssetsLoad();
    this.audioLoad();

    this.load.start();

    this.load.on(
      'progress',
      function () {
        this.loadingAnim.anim.playSegments([0, 25], true);
      },
      this,
    );

    this.load.on(
      'complete',
      function () {
        this.loadingAnim.anim.loop = false;
        this.loadingAnim.anim.playSegments([26, 41], true);
        this.loadingAnim.anim.addEventListener('complete', () => {
          this.scene.stop('LoadScene');
          this.scene.start('StartScene');
        });
      },
      this,
    );
  }

  addLoaderLottie(_x, _y) {
    const lottieRef = this.add
      .dom(_x - this.cameras.main.width / 2, _y - this.cameras.main.height / 2, 'div')
      .setScale(0.7);

    const lottieDiv = lottieRef.node;
    lottieDiv.style.height = '100%';
    lottieDiv.style.width = '100%';

    const lottieAnim = lottie.loadAnimation({
      container: lottieDiv,
      renderer: 'svg',
      loop: true,
      autoplay: false,
      animationData: this.cache.json.get('loading-anim'),
    });

    return { anim: lottieAnim, dom: lottieRef };
  }

  audioLoad() {
    this.load.audio('bgMusic', 'assets/Audio/mysterious-cave-ambiance-1.mp3');
    this.load.audio('doorUnlock', 'assets/Audio/Automatic-door-unlock-slide-open.mp3');
    this.load.audio('logoReveal', 'assets/Audio/Beauty-intro-reveal-logo-2.mp3');
    this.load.audio('keyTurn', 'assets/Audio/Doorknob-unlock.mp3');
    this.load.audio('correctAnswer', 'assets/Audio/Feedback-correct.mp3');
    this.load.audio('incorrectAnswer', 'assets/Audio/Error-prompt-alert.mp3');
    this.load.audio('chestOpen', 'assets/Audio/Wood-chest-cover-opening.mp3');
    this.load.audio(
      'gemReveal',
      'assets/Audio/New-level-up-2-upgrade-1up-videogame-upgrade-1up-videogame.mp3',
    );
    this.load.audio('confetti', 'assets/Audio/confetti.wav');
  }

  endSceneAssetsLoad() {
    // intentionally empty in original source
  }

  startSceneAssetsLoad() {
    this.load.image('play_button', 'assets/StartSceneAssets/play_button.png');
    this.load.image('play_button_on', 'assets/StartSceneAssets/play_button_on.png');
    this.load.image('Background', 'assets/StartSceneAssets/Background.png');
    this.load.image('box', 'assets/StartSceneAssets/box.png');
    this.load.image('web', 'assets/StartSceneAssets/web.png');
  }

  update() {}
}
